<h3 mat-dialog-title>Zbyt wysoka suma kwot płatności</h3>

<div>
  Opłaty nie mogą zostać dodane do koszyka, ponieważ suma kwot płatności bez weryfikacji konta nie może przekroczyć
  500,00&nbsp;zł.<br />
  Aby móc dodać zaznaczone opłaty do koszyka, konieczna jest weryfikacja konta użytkownika.
</div>

<div matDialogActions align="end">
  <button mat-button matDialogClose (click)="goBack()">Zamknij</button>
  <button
    color="primary"
    mat-raised-button
    matDialogClose
    [appApiCallLoading]="verifyPhoneNumber"
    preserveQueryParams="true"
  >
    Zweryfikuj konto
  </button>
</div>
